import ImageOptimizer from '@/components/image-optimizer';
import { TheoryExamLicenseEntity } from '@/data/exam/exam.data';

interface Props {
  items: TheoryExamLicenseEntity[];
}

type GroupedField = {
  content: string;
  count: number;
};
type GroupedResult = Record<string, GroupedField[]>;

export default function WebLicenseTable({ items }: Props) {
  const webLicenseList = items.sort((a, b) => a.webSeq - b.webSeq);

  const groupFields = ['examEligibility', 'passingCriteria', 'fee'] as const;

  const groupedData: GroupedResult = {};

  groupFields.forEach((field) => {
    const countMap = new Map<string, number>();

    webLicenseList.forEach((item) => {
      const key = String(item[field]);
      countMap.set(key, (countMap.get(key) || 0) + 1);
    });

    // 객체 배열 형태로 변환
    groupedData[field] = Array.from(countMap.entries()).map(
      ([content, count]) => ({
        content,
        count,
      }),
    );
  });

  return (
    <div className="relative">
      <div className="desktop:grid relative z-1 hidden w-full [grid-template-columns:75px_repeat(auto-fit,minmax(0,1fr))] divide-x divide-dotted divide-[#969aaf]">
        <div className="flex flex-col gap-6 pb-[30px]">
          <div className="h-[208px]"></div>
          <span className="text-font-grayblue typo-16 flex h-[88px] items-center font-bold">
            합격기준
          </span>
          <span className="text-font-grayblue typo-16 flex h-[126px] items-center font-bold">
            시험자격
          </span>
          <span className="text-font-grayblue typo-16 flex h-[88px] items-center font-bold">
            수수료
          </span>
        </div>
        {webLicenseList.map((item, idx) => (
          <div className="flex h-full flex-col" key={item.licenseType + idx}>
            <div className="mb-6 flex flex-col items-center gap-3 pt-[29px]">
              <span className="text-level-2 typo-22 font-bold">
                {item.licenseType}
              </span>
              <span className="typo-16 text-level-4 h-4 font-medium">
                {item.subLicenseType}
              </span>
            </div>
            <div className="relative mb-8 flex items-center justify-center">
              <ImageOptimizer
                src={item.iconUrl}
                alt={item.licenseType + ' icon'}
                width={92}
                height={70}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-[30px] left-[94px] z-0 flex w-full flex-col gap-6">
        {/**합격기준 */}
        <div className="flex gap-10">
          {groupedData.passingCriteria.map((item, idx) => (
            <div
              className="typo-18 text-level-2 flex h-[88px] items-center justify-center rounded-[10px] bg-[#FFFACB] text-center leading-snug font-semibold"
              key={item.content + '-absolute-' + idx}
              style={{ width: `${item.count * 200 + (item.count - 2) * 20}px` }}
            >
              {item.content}
            </div>
          ))}
        </div>
        {/**시험자격 */}
        <div className="flex gap-10">
          {groupedData.examEligibility.map((item, idx) => (
            <div
              key={item.content + '-absolute-' + idx}
              className="typo-18 text-level-2 flex h-[126px] items-center justify-center rounded-[10px] bg-[#FFFACB] text-center leading-snug font-semibold"
              dangerouslySetInnerHTML={{
                __html: item.content.replace(/\n/g, '<br/>'),
              }}
              style={{ width: `${item.count * 200 + (item.count - 2) * 20}px` }}
            ></div>
          ))}
        </div>
        {/**수수료 */}
        <div className="flex gap-10">
          {groupedData.fee.map((item, idx) => (
            <div
              key={item.content + '-absolute-' + idx}
              className="typo-18 text-level-2 bg-bg-graylight flex h-[88px] items-center justify-center rounded-[10px] text-center leading-snug font-semibold"
              style={{ width: `${item.count * 200 + (item.count - 2) * 20}px` }}
            >
              수수료 {Number(item.content).toLocaleString()}원
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
